module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "content-icons-ui": "static-1.2417"
    },
    "depPathPrefixes": {
      "content-icons-ui": "/content-icons-ui/static-1.2417"
    },
    "bundlingPackage": "deal-plans-ui",
    "bundlingPackageVersion": "static-1.2310",
    "project": "content-icons-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};